const journeyRecordsPages = {
    GridEmpresasJornada: import(
        "./jornada/cadastros/empresa/GridEmpresasJornada.js"
    ),
    GridMotoristasJornada: import(
        "./jornada/cadastros/motorista/GridMotoristasJornada.js"
    ),
    GridVeiculosJornada: import(
        "./jornada/cadastros/veiculo/GridVeiculosJornada.js"
    ),
    GridEscalasJornada: import(
        "./jornada/cadastros/empresa/escala/GridEscalasJornada.js"
    ),
    CadastroArvoreDecisao: import(
        "./jornada/cadastros/arvoreDecisao/CadastroArvoreDecisao.tsx"
    ),
};

const journeyReportsPages = {
    CartaoPontoSintetico: import(
        "./jornada/relatorios/CartaoPontoSintetico/CartaoPontoSintetico.js"
    ),
    CartaoPontoSinteticoAntigo: import(
        "./jornada/relatorios/CartaoPontoSintetico/CartaoPontoSinteticoAntigo.js"
    ),
    GridListaDeRelatorios: import(
        "./jornada/relatorios/GridListaDeRelatorios.js"
    ),
    RelatorioAfastamentos: import(
        "./jornada/relatorios/RelatorioAfastamentos/"
    ),
    RelatorioKmDiariosMotoristas: import(
        "./jornada/relatorios/RelatorioKmDiariosMotoristas.js"
    ),
    RelatorioAcessos: import("./jornada/relatorios/RelatorioAcessos.js"),
    RelatorioHorasFalta: import("./jornada/relatorios/RelatorioHorasFalta.js"),
    RelatorioAtivacaoMotoristas: import(
        "./jornada/relatorios/RelatorioAtivacaoMotoristas.js"
    ),
    RelatorioDSR: import("./jornada/relatorios/RelatorioDSR.js"),
    RelatorioFaltaDescansoRepouso: import(
        "./jornada/relatorios/RelatorioFaltaDescansoRepouso.js"
    ),
    RelatorioEventos: import("./jornada/relatorios/RelatorioEventos/index.js"),
    RelatorioOcorrencias: import(
        "./jornada/relatorios/RelatorioOcorrencias.js"
    ),
    RelatorioProdutividade: import(
        "./jornada/relatorios/RelatorioProdutividade/"
    ),
    RelatorioAnomalias: import("./jornada/relatorios/RelatorioAnomalias/"),
    RelatorioNaoConformidades: import(
        "./jornada/relatorios/RelatorioNaoConformidades/"
    ),
    RelatorioAlteracoesViaMobile: import(
        "./jornada/relatorios/RelatorioAlteracoesViaMobile/"
    ),
    RelatorioDiarias: import("./jornada/relatorios/RelatorioDiarias/"),
    RelatorioMensagensJornada: import(
        "./jornada/relatorios/RelatorioMensagensJornada/"
    ),
    RelatorioBancoDeHoras: import(
        "./jornada/relatorios/RelatorioBancoDeHoras/"
    ),
    RelatorioExcecoes: import("./jornada/relatorios/RelatorioExcecoes/"),
    RelatorioTratativaExcecoes: import(
        "./jornada/relatorios/RelatorioTratativaExcecoes"
    ),
    RelatorioAnotacoesJornada: import(
        "./jornada/relatorios/RelatorioAnotacoesJornada"
    ),
};

const journeyManagementPages = {
    GridControleJornada: import(
        "./jornada/gestaojornada/GridControleJornada.js"
    ),
    GridControleJornada2: import(
        "./jornada/gestaojornada/GridControleJornada2.js"
    ),
    AssinaturaEletronica: import("./jornada/AssinaturaEletronica/"),
};

const journeyMiscPages = {
    Dashboards: import("./Dashboards/"),
    SystemIndicatorsManagement: import("./SystemIndicatorsManagement/"),
    TelaCadastroBIJornada: import(
        "./jornada/businessIntelligence/TelaCadastroBIJornada.js"
    ),
    TelaPaineisBIJornada: import(
        "./jornada/businessIntelligence/TelaPaineisBIJornada.js"
    ),
    TelaVisaoBIJornada: import(
        "./jornada/businessIntelligence/TelaVisaoBIJornada.js"
    ),
};

const journeyConfigrationPages = {
    TelasSistema: import("./jornada/configuracoes/TelasSistema/"),
    MenusSistema: import("./jornada/configuracoes/MenusSistema/"),
    UsuariosSistema: import("./jornada/configuracoes/UsuariosSistema/"),
    PlanosSistema: import("./jornada/configuracoes/PlanosSistema/"),
    VinculosEmpresaPlano: import(
        "./jornada/configuracoes/VinculosEmpresaPlano/"
    ),
    PermissoesSistema: import("./jornada/configuracoes/PermissoesSistema/"),
    PermissoesSistemaPorUsuario: import(
        "./jornada/configuracoes/PermissoesSistemaPorUsuario/"
    ),
};

export default {
    ...journeyRecordsPages,
    ...journeyReportsPages,
    ...journeyManagementPages,
    ...journeyMiscPages,
    ...journeyConfigrationPages,
};
